import { Reducer } from 'react';
import { ApplicationAction, ApplicationState } from './types';
import { defaultSections, InitialTimeStampState } from './config';

export const InitialApplicationState: ApplicationState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  modalsOpen: null,
  actions: {
    anchorEl: null
  },
  sortableSections: defaultSections,
  emailPlaceholders: '',
  editedTask: null,
  selectedAttachmentAction: {
    preview: null,
    delete: null
  },
  selectedFormResponseAction: {
    edit: null,
    delete: null
  },
  timeStampState: InitialTimeStampState,
  isAdminUser: false,
  userTimeZone: '',
  focused: false,
  userEmail: '',
  overviewTab: { note: '', hasUnsavedChanges: false },
  referenceId: null,
  selectedReferee: null
};

export const ApplicationReducer: Reducer<ApplicationState, ApplicationAction> = (
  state: ApplicationState,
  action: ApplicationAction
) => {
  switch (action.type) {
    case 'SET_USER_DATA':
      return {
        ...state,
        isAdminUser: action.payload.isAdminUser,
        userTimeZone: action.payload.userTimeZone,
        userEmail: action.payload.userEmail
      };
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_MODALS_OPEN':
      return { ...state, modalsOpen: action.payload };
    case 'SET_ACTIONS':
      return { ...state, actions: action.payload };
    case 'SET_SORTABLE_SECTIONS':
      return { ...state, sortableSections: action.payload };
    case 'SET_EMAIL_PLACEHOLDERS':
      return { ...state, emailPlaceholders: action.payload };
    case 'SET_EDITED_TASK':
      return { ...state, editedTask: action.payload };
    case 'SET_SELECTED_ATTACHMENT_ACTION':
      return { ...state, selectedAttachmentAction: action.payload };
    case 'SET_SELECTED_FORM_RESPONSE_ACTION':
      return { ...state, selectedFormResponseAction: action.payload };
    case 'SET_TIMESTAMP_STATE':
      return {
        ...state,
        timeStampState: { ...state.timeStampState, [action.payload.name]: action.payload.value }
      };
    case 'RESET_TIMESTAMP_STATE':
      return { ...state, timeStampState: InitialTimeStampState };
    case 'SET_FOCUSED':
      return { ...state, focused: action.payload };
    case 'SET_OVERVIEW_TAB':
      return {
        ...state,
        overviewTab: {
          ...state.overviewTab,
          ...action.payload
        }
      };
    case 'SET_UNUSUAL_ACTIVITY_DATA':
      return {
        ...state,
        referenceId: action.payload.referenceId,
        selectedReferee: action.payload.selectedReferee
      };
    default:
      return state;
  }
};
